export default function initialize() {
    $(document).on('click', '[name=brandCode], #issuerList', (e) => {
        $('#adyenPaymentMethod').val($(e.currentTarget).closest('.paymentMethod').find('label').text());
        if ($(e.currentTarget).parent().find('#issuerList').length) {
            $('#adyenIssuerName').val($('#issuerList :selected').attr('label'));
        } else {
            $('#issuerList').val('');
            $('#adyenIssuerName').val('');
        }
    });
}
